// extracted by mini-css-extract-plugin
export default {"instructions":"instructionsTab_instructions__Dri2e","instructionImage":"instructionsTab_instructionImage__a6Guq"};